import styled from 'styled-components';
import { color, size } from "./helpers/variables";

export const UnderlinedHeading = styled.p`
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2px;
  text-align: left;
  color: ${color.black};
  display: block;
  border-bottom: solid 1px #c5c5c5;
  text-transform: uppercase;
  padding-bottom: 4px;
  margin: 30px 0 15px;
  
  @media screen and (min-width: ${size.large}px) {
    font-size: 13px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/UnderlinedHeading.js